/* import __COLOCATED_TEMPLATE__ from './class-group-fis-points-card.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';

export default class ClassGroupPenaltiesCardComponent extends Component 
{
	@service store;
	
	@tracked classGroup = null;
	
	@tracked selectedClassGroupPts = null;
	@tracked selectedClassGroupPtsName = null;
	
	@tracked selectedRacePts = null;
	@tracked selectedRacePtsName = null;
	
	@action
	async selectClassGroup(event)
	{
		var classGroupId = event.target.value;
		
		if(classGroupId == '-')
		{
			this.classGroup = null;
		}
		else
		{
			this.classGroup = await this.store.findRecord('classGroup', classGroupId);
			this.calculateRacePoints();
		}
	}
	
	@action
	selectClassGroupPts(event)
	{
		var ptsCol = event.target.value;
		
		if(ptsCol == '-')
		{
			this.selectedClassGroupPts = null;
			this.selectedClassGroupPtsName = null;
		}
		else
		{
			this.selectedClassGroupPts = ptsCol;
			this.selectedClassGroupPtsName = ptsCol+"Name";
		}
		this.calculateRacePoints();
	}
	
	@action
	selectRacePts(event)
	{
		var ptsCol = event.target.value;
		
		if(ptsCol == '-')
		{
			this.selectedRacePts = null;
			this.selectedRacePtsName = null;
		}
		else
		{
			this.selectedRacePts = ptsCol;
			this.selectedRacePtsName = ptsCol+"Name";
		}
	}
	
	@action
	async savePoints()
	{
		if(this.classGroup && this.selectedClassGroupPts && this.selectedRacePts)
		{
			var results = await this.classGroup.get('results');
			await this.args.event.hasMany('entries').reload();
			var entries = [...(await this.args.event.get('entries'))];
			for(var result of [...results])
			{
				for(var entry of entries)
				{
					if(entry.bib == result.bib)
					{
						entry.set(this.selectedRacePts,result.calculatedRacePoints);
						entry.save();
					}
				}
			}
		}
	}
	
	async calculateRacePoints()
	{
		if(this.classGroup && this.selectedClassGroupPts)
		{
			var fValue = parseInt(this.classGroup.get(this.selectedClassGroupPts));
			var results = await this.classGroup.get('results');
			var firstPlaceResult = [...results][0];
			for(var result of [...results])
			{
				var resultTime = result.totalTimeInMilliseconds;
				if(resultTime)
				{
					var rP = (resultTime-firstPlaceResult.totalTimeInMilliseconds)/firstPlaceResult.totalTimeInMilliseconds*fValue;
					result.set('calculatedRacePoints',rP.toFixed(2));
				}
			}
		}
	}
}